var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isInit
    ? _c(
        "div",
        { staticClass: "item-list" },
        [
          _vm.field.name
            ? _c(
                "div",
                { staticClass: "label-item" },
                [
                  _c("p", { staticClass: "label-text" }, [
                    _vm._v(_vm._s(_vm.field.desc))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { effect: "light", placement: "bottom-start" }
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _vm._v("\n                - name: "),
                          _c("strong", [_vm._v(_vm._s(_vm.field.name))]),
                          _c("br"),
                          _vm._v(
                            "\n                - 可以设置多项，点击 + 号新增；\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("i", { staticClass: "label-icon el-icon-info" })
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.field.def_val || !_vm.field.def_val.length
            ? _c("div", { staticClass: "no-item" }, [
                _vm._v("暂无内容，点击 + 号新增")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { model: _vm.field, "label-width": "120px" }
            },
            [
              _c(
                "draggable",
                {
                  staticClass: "item-drag-area",
                  attrs: { list: _vm.field.def_val, options: _vm.draggableOpt }
                },
                _vm._l(_vm.field.def_val, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "input-group drag-item" },
                    [
                      _c("span", { staticClass: "group-label" }, [
                        _vm._v(_vm._s("第(" + (index + 1) + ")项"))
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "input-row",
                          attrs: {
                            label: "p1",
                            prop: "def_val[" + index + "].p1",
                            rules: _vm.fieldRules
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "field-input",
                            attrs: {
                              placeholder:
                                "请填写'" +
                                (_vm.field.desc || "") +
                                "(p1)'的内容"
                            },
                            model: {
                              value: item.p1,
                              callback: function($$v) {
                                _vm.$set(item, "p1", $$v)
                              },
                              expression: "item.p1"
                            }
                          }),
                          _vm._v(" "),
                          _c("renderPreview", { attrs: { val: item.p1 } })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "input-row",
                          attrs: {
                            label: "p2",
                            prop: "def_val[" + index + "].p2",
                            rules: _vm.fieldRules
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "field-input",
                            attrs: {
                              placeholder:
                                "请填写'" +
                                (_vm.field.desc || "") +
                                "(p2)'的内容"
                            },
                            model: {
                              value: item.p2,
                              callback: function($$v) {
                                _vm.$set(item, "p2", $$v)
                              },
                              expression: "item.p2"
                            }
                          }),
                          _vm._v(" "),
                          _c("renderPreview", { attrs: { val: item.p2 } })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "input-row",
                          attrs: {
                            label: "p3",
                            prop: "def_val[" + index + "].p3",
                            rules: _vm.fieldRules
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "field-input",
                            attrs: {
                              placeholder:
                                "请填写'" +
                                (_vm.field.desc || "") +
                                "(p3)'的内容"
                            },
                            model: {
                              value: item.p3,
                              callback: function($$v) {
                                _vm.$set(item, "p3", $$v)
                              },
                              expression: "item.p3"
                            }
                          }),
                          _vm._v(" "),
                          _c("renderPreview", { attrs: { val: item.p3 } })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "input-row",
                          attrs: {
                            label: "p4",
                            prop: "def_val[" + index + "].p4",
                            rules: _vm.fieldRules
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "field-input",
                            attrs: {
                              placeholder:
                                "请填写'" +
                                (_vm.field.desc || "") +
                                "(p4)'的内容"
                            },
                            model: {
                              value: item.p4,
                              callback: function($$v) {
                                _vm.$set(item, "p4", $$v)
                              },
                              expression: "item.p4"
                            }
                          }),
                          _vm._v(" "),
                          _c("renderPreview", { attrs: { val: item.p4 } })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "input-row",
                          attrs: {
                            label: "p5",
                            prop: "def_val[" + index + "].p5",
                            rules: _vm.fieldRules
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "field-input",
                            attrs: {
                              placeholder:
                                "请填写'" +
                                (_vm.field.desc || "") +
                                "(p5)'的内容"
                            },
                            model: {
                              value: item.p5,
                              callback: function($$v) {
                                _vm.$set(item, "p5", $$v)
                              },
                              expression: "item.p5"
                            }
                          }),
                          _vm._v(" "),
                          _c("renderPreview", { attrs: { val: item.p5 } })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-button", {
                        staticClass: "remove-btn",
                        attrs: { icon: "el-icon-delete", title: "删除该项" },
                        on: {
                          click: function($event) {
                            return _vm.remove(index)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("el-button", {
                        staticClass: "move-btn",
                        attrs: { icon: "el-icon-rank", title: "拖动此项" }
                      })
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "add-btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.add }
                    },
                    [_vm._v("+")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-279136ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-279136ba","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/compEditForm/itemList.vue
// module id = 1215
// module chunks = 7